import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Atualiza o state para mostrar a UI de erro
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log do erro para debugging
        console.error('ErrorBoundary capturou um erro:', error, errorInfo);
        
        // Redireciona para a página principal após 3 segundos
        setTimeout(() => {
            window.location.href = '/';
        }, 3000);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-page d-flex align-items-center justify-content-center min-vh-100">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 text-center">
                                <div className="error-content">
                                    <h1 className="error-title mb-4" style={{ fontSize: '4rem', color: '#5236FF' }}>Oops!</h1>
                                    <h2 className="mb-3">Algo deu errado</h2>
                                    <p className="mb-4 text-muted">
                                        Ocorreu um erro inesperado. Não se preocupe, você será redirecionado 
                                        para a página principal em alguns segundos.
                                    </p>
                                    <div className="d-flex justify-content-center align-items-center mb-4">
                                        <div className="spinner-border text-primary me-3" role="status">
                                            <span className="visually-hidden">Carregando...</span>
                                        </div>
                                        <span>Redirecionando...</span>
                                    </div>
                                    <button 
                                        onClick={() => window.location.href = '/'}
                                        className="btn btn-primary btn-lg"
                                        style={{ backgroundColor: '#5236FF', borderColor: '#5236FF' }}
                                    >
                                        Ir para Página Principal
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary; 